import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import NavBar from "../../components/NavBar";
import Footer from "../../components/Footer";
import Section from "../Originstory/Section";
import Colors from "../../asstes/color";
import image1 from '../../asstes/images/about_us/image1.png';
import image2 from '../../asstes/images/about_us/image2.png';
import image3 from '../../asstes/images/about_us/image3.png';

function AboutUsPage() {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className="content-page">
      <NavBar screen={"event"} />

      <Box
        sx={{
          mt: { xs: 4, md: 8 },
          mb: { xs: 6, md: 10 },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontFamily: "MyCustomFont",
            fontWeight: 700,
            color: Colors.textSecondary,
            fontSize: { xs: "2.2rem", md: "3.5rem" },
            textAlign: "center",
            px: 2,
          }}
        >
          The Social Paws Way!
        </Typography>
      </Box>

      <Section
        title="Milestone #1"
        description="Use our Offer a Walk feature to suggest a time and place for your first in-person Group Walk. A Group Walk includes the Pup, Pup Pawrent, and Pup Pal, giving everyone the opportunity to get to know one another. This is your chance to ask questions, share information, and see how everyone—including the dog—connects. We recommend completing at least two Group Walks before moving forward. During the second walk, the Pup Pawrent can begin stepping back while the Pup Pal practices walking the dog independently."
        image={image1}
        reverse={false}
      />

      <Section
        title="Milestone #2"
        description="When everyone feels comfortable, it's time for the Pup Pawrent to Pass the Leash and the Pup Pal to Take the Leash. The Pup Pal can enjoy a solo walk, playdate, or other agreed-upon activity with the dog. A playdate might mean having the dog over while working from or relaxing at home."
        image={image2}
        reverse={true}
      />

      <Section
        title="Milestone #3"
        description="Trust is built by stacking positive experiences. As the relationship continues to grow, the final milestone is for both the Pup Pawrent and Pup Pal to designate one another as Trusted. Reaching this milestone unlocks anytime access and first-to-know notifications when a dog's availability is posted. It also allows Trusted connections to book walks, playdates, adventures, and overnight stays without using the Offer a Walk process, making it easy to spend time together whenever they'd like. At Social Paws, every relationship begins with a simple Treat and grows through connection, trust, and community."
        image={image3}
        reverse={false}
      />

      <Footer />
    </Box>
  );
}

export default AboutUsPage;
